import { render, staticRenderFns } from "./contractItem.vue?vue&type=template&id=6833b1db&scoped=true&"
import script from "./contractItem.vue?vue&type=script&lang=js&"
export * from "./contractItem.vue?vue&type=script&lang=js&"
import style0 from "./contractItem.vue?vue&type=style&index=0&id=6833b1db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833b1db",
  null
  
)

export default component.exports